export default __webpack_public_path__ + "static/media/css-logo.83cd91f3.svg";